import { ClickAwayListener, useMediaQuery } from '@material-ui/core';
import { AlarmBellIcon } from 'components/icons';
import React, { FC, memo } from 'react';

import { from } from 'styles/mixins';
import ActivityList from '../ActivityList';
import { useConnect } from './connect';
import {
  BellContainer,
  Button,
  ClickAwayContainer,
  Container,
  NewNotificationsIndicator,
  ResponsivePopper,
} from './styles';
import { Props } from './types';

const NotificationsButton: FC<Props> = ({
  showNotificationsMenu,
  closeNotificationsMenu,
  toggleNotificationsMenu,
  hasUnread,
}) => {
  const { anchorRef } = useConnect();
  const isTabletH = useMediaQuery(from.tabletH.query);

  return (
    <Container>
      <Button
        ref={anchorRef}
        $unread={hasUnread}
        aria-label="Activity"
        onClick={toggleNotificationsMenu}
      >
        <BellContainer>
          <AlarmBellIcon />
          {hasUnread && <NewNotificationsIndicator />}
        </BellContainer>
      </Button>

      <ResponsivePopper
        open={showNotificationsMenu}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        modifiers={{
          flip: { enabled: true },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'viewport',
          },
          offset: {
            enabled: true,
            offset: '0, 8',
          },
        }}
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener
          onClickAway={isTabletH ? closeNotificationsMenu : () => {}}
        >
          <ClickAwayContainer>
            <ActivityList handleClose={closeNotificationsMenu} />
          </ClickAwayContainer>
        </ClickAwayListener>
      </ResponsivePopper>
    </Container>
  );
};

export default memo(NotificationsButton);
